import { buyerExistingInventoryCorrections } from '../../../requests/api-endpoints';

const getExistingInventoryCorrectionUrlParams = (requestParams) => {

  const { locationId, orderNumber, sortBy, supplierName, equipmentNumber, sortDir } = requestParams;

  const params = new URLSearchParams();

  if (locationId) {
    params.append("locationId", locationId)
  }
  if (orderNumber) {
    params.append("orderNumber", orderNumber)
  }
  if (sortBy && sortBy !== 'none') {
    params.append("sortBy", sortBy)
  }
  if (supplierName) {
    params.append("supplierName", supplierName?.trim())
  }
  if (equipmentNumber) {
    params.append("equipmentNumber", equipmentNumber)
  }
  if (sortDir) {
    params.append("sortDir", sortDir)
  }

  return params;
}

export const getExistingBuyerInventoryCorrectionUrl = (accountId, searchParams) => {
  return `${buyerExistingInventoryCorrections.search}?${getExistingInventoryCorrectionUrlParams(searchParams)}`;
}
